/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Priority levels for support tickets
 */
export enum TicketPriority {

    Low = 'low',

    Medium = 'medium',

    High = 'high',

    Urgent = 'urgent'
}
